<div class="custom-mat-dialog-form">
  <div>
    <h3>{{this.data.ActionItemId ? 'Update' : 'Create new'}} Action Item for {{this.data.measureDescription}}</h3>
  </div>
  <div>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-sm-6 form-group">
          <div>
            <mat-form-field appearance="outline">
              <mat-label>Action Item Name</mat-label>
              <input matInput formControlName="name" required>
            </mat-form-field>

            @if (
              form.get('name')?.invalid &&
              (form.get('name')?.dirty ||
              form.get('name')?.touched)) {
              <p>
                @if (form.get('name')?.hasError('required')) {
                  <mat-error>This field is required</mat-error>
                }
              </p>
            }
          </div>

        </div>
        <div class="col-sm-6 form-group">
          <div>
            <mat-form-field appearance="outline">
              <mat-label>Owner</mat-label>
              <input matInput formControlName="owner" required>
            </mat-form-field>
          </div>

        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 form-group">
          <div>
            <mat-form-field appearance="outline">
              <mat-label>Description</mat-label>
              <input matInput formControlName="description" required>
            </mat-form-field>
          </div>

        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 form-group">
          <div>
            <mat-form-field appearance="outline">
              <mat-label>Deadline</mat-label>
              <input matInput [matDatepicker]="picker" [min]="isCreate ? minDate : null"
                formControlName="deadline"
                (dateChange)="onDateChange($event, 'deadline')"
                format="yyyy-MM-dd" required>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </div>

          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 form-group">
            <div>
              <mat-form-field appearance="outline">
                <mat-label>Comments</mat-label>
                <input matInput formControlName="comments">
              </mat-form-field>
            </div>

          </div>
        </div>
        <div class="row">
          <div class="panel-body">
            <button (click)="backButtonHandler($event)" mat-raised-button class="btn  button-color-fix_red ">
              <mat-icon class=" icon-color-fix ">arrow_back_ios</mat-icon>
              Back
            </button>
            <button mat-raised-button type="submit" class="btn button-color-fix pull-right" [disabled]="!form.valid">
              {{buttonLabel}}
              <mat-icon class=" icon-color-fix ">{{buttonIcon}}</mat-icon>
            </button>

          </div>
        </div>
      </form>
    </div>
  </div>
